import { render } from "./GenerateParcel.vue?vue&type=template&id=c5b0addc&scoped=true"
import script from "./GenerateParcel.vue?vue&type=script&lang=js"
export * from "./GenerateParcel.vue?vue&type=script&lang=js"

import "./GenerateParcel.vue?vue&type=style&index=0&id=c5b0addc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c5b0addc"

export default script